import React from 'react';
import FinancialCalendar from './FinancialCalendar';
import './index.css';

function App() {
  return (
    <div className="App">
      <FinancialCalendar />
    </div>
  );
}

export default App;